import { Slider } from "antd";
import { Control, Controller } from "react-hook-form";

interface IProps {
  name: string;
  label: string;
  control: Control<any, any>;
  defaultValue?: number[];
  min?: number;
  max?: number;
}

export default function LabeledSliderInput({
  name,
  label,
  control,
  defaultValue,
  max,
  min,
}: IProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <div className="w-full">
          <label
            htmlFor={name}
            className="pl-1"
            style={{ color: "rgba(0,0,0,.7)", fontSize: ".85rem" }}
          >
            {label}
          </label>
          <Slider
            range
            defaultValue={defaultValue}
            max={max}
            min={min}
            {...field}
          />
          <span className="text-xs text-red-500">{error?.message}</span>
        </div>
      )}
    />
  );
}
